import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import MarketingLayout, { PageMeta } from "@/components/MarketingLayout";

export default function NotFound() {
  return (
    <MarketingLayout>
      <PageMeta title="Page Not Found | Nothing Before Law" description="The requested page could not be found." />
      <section className="mx-auto flex min-h-[60dvh] max-w-3xl flex-col items-start justify-center px-4 py-16 sm:px-6 lg:px-8">
        <p className="marketing-eyebrow">Page not found</p>
        <h1 className="mt-5 font-serif text-5xl leading-tight text-[var(--m-text)] sm:text-6xl">This page is not in the diary.</h1>
        <p className="mt-5 text-lg leading-7 text-[var(--m-muted)]">The address may be incomplete or the page may have moved.</p>
        <Link to="/" className="marketing-primary-button mt-8"><ArrowLeft size={17} weight="bold" /> Back home</Link>
      </section>
    </MarketingLayout>
  );
}
